export enum GroupType {
  Communities = '_communities',
  Events = '_events',
  Ideas = '_ideas',
  FakeType = 'any',
}
